module.exports = __webpack_public_path__ + "static/img/restaurant-filter-icon05.4faef137.svg";